"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_saving_1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x37_9338293-aef7-4354-a7b7-cb01b3545ed2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 192 192",
    enableBackground: "new 0 0 192 192",
    xmlSpace: "preserve",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("title", null, "saving-hi"), /*#__PURE__*/React.createElement("g", {
    id: "_x36_ba24b11-2f05-4714-8877-fb8f98e3e744"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EBEBEB",
    d: "M64,16h64c4.4182739,0,8,3.5817223,8,8v144c0,4.4182739-3.5817261,8-8,8H64c-4.4182777,0-8-3.5817261-8-8 V24C56,19.5817223,59.5817223,16,64,16z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    enableBackground: "new    ",
    d: "M128,174H64c-4.4182777,0-8-3.5817261-8-8v2c0,4.4182739,3.5817223,8,8,8h64 c4.4182739,0,8-3.5817261,8-8v-2C136,170.4182739,132.4182739,174,128,174z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M62,32h68c1.1045685,0,2,0.8954315,2,2v118c0,1.1045685-0.8954315,2-2,2H62c-1.1045685,0-2-0.8954315-2-2 V34C60,32.8954315,60.8954315,32,62,32z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 48.0857887,
    y1: 148.9142151,
    x2: 143.9142151,
    y2: 53.0857887,
    gradientTransform: "matrix(1 0 0 -1 0 194)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F6F6F6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fill: "url(#SVGID_1_)",
    enableBackground: "new    ",
    d: "M62,32h68c1.1045685,0,2,0.8954315,2,2v118 c0,1.1045685-0.8954315,2-2,2H62c-1.1045685,0-2-0.8954315-2-2V34C60,32.8954315,60.8954315,32,62,32z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.24
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M130,33c0.5522919,0,1,0.4477158,1,1v118c0,0.5522919-0.4477081,1-1,1H62c-0.5522842,0-1-0.4477081-1-1V34 c0-0.5522842,0.4477158-1,1-1H130 M130,32H62c-1.1045685,0-2,0.8954315-2,2v118c0,1.1045685,0.8954315,2,2,2h68 c1.1045685,0,2-0.8954315,2-2V34C132,32.8954315,131.1045685,32,130,32z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#4A4D4E",
    d: "M88.7099991,24h14.5800018C103.6821213,24,104,24.3178768,104,24.7099991v0.5800018 C104,25.6821232,103.6821213,26,103.2900009,26H88.7099991C88.3178787,26,88,25.6821232,88,25.2900009v-0.5800018 C88,24.3178768,88.3178787,24,88.7099991,24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E60000",
    d: "M82.7099991,24h0.5800018C83.6821213,24,84,24.3178768,84,24.7099991v0.5800018 C84,25.6821232,83.6821213,26,83.2900009,26h-0.5800018C82.3178787,26,82,25.6821232,82,25.2900009v-0.5800018 C82,24.3178768,82.3178787,24,82.7099991,24z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E60000",
    cx: 96,
    cy: 164,
    r: 6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_x35_6397991-c8b2-4d64-a851-38b774a7f51c",
    fill: "none",
    width: 192,
    height: 192
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E60000",
    d: "M146.3999939,85.9979935V67.6019974c-23.3519897,0-38.723999,7.140007-50.3999939,22.8480072 c4.7040024-22.4280014,17.723999-44.7720032,50.3999939-49.3080025V23.2499943L180,54.5819893 C180,54.5819893,146.3999939,85.9979858,146.3999939,85.9979935z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#EBEBEB",
    d: "M55.7939911,174.5704041v-7.8056488l-5.9609909,1.1386871l-2.9548759-1.4916687l10.4701614-2.0439301 h4.95895v10.1741028L55.7939911,174.5704041z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EBEBEB",
    d: "M33.510025,166.5199432c0,5.7674103,15.7821007,10.4416962,35.2535248,10.4416962 c19.1355209,0,34.6955795-4.5148621,35.2364502-10.1399384V153.687027h-5.0443497v1.0305023 c-6.1602631-1.9585266-17.3762589-3.2680054-30.2205658-3.2680054s-24.0659981,1.3094788-30.2205658,3.2680054v-1.0305023 h-5.0329628v12.8329163H33.510025z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_2_",
    d: "M33.510025,166.5142517c0,5.7674103,15.7821007,10.4359894,35.2592163,10.4359894 c19.107048,0,34.6614151-4.4977722,35.2307587-10.1171722V153.687027h-5.0443497v1.0305023 c-6.1602631-1.9585266-17.3762589-3.2680054-30.2205658-3.2680054s-24.0659981,1.3094788-30.2205658,3.2680054v-1.0305023 h-5.0329628v12.8272247H33.510025z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_3_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_2_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_3_)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.3571472,155.730957v17.2509918c1.9194641,0.7330322,3.881588,1.3490448,5.8755875,1.8446655V155.730957H39.3571472z "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1310959,155.7024841v21.0655823c1.8978004,0.223938,3.8525352,0.4289093,5.8642006,0.6148834v-21.6804657 H51.1310959z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8651924,160.9688873v18.0195923c1.924366,0.0683289,3.8885918,0.1252594,5.8755836,0.1708069v-18.1903992 H62.8651924z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.6163635,161.9538422v15.6682281c1.981308-0.0284729,3.9455261-0.0626221,5.8755875-0.1138611v-15.5543671 H74.6163635z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.3675385,161.2535553v16.3969879c2.0154648-0.1594086,3.9739914-0.3340149,5.8755875-0.5237885v-15.8731995 H86.3675385z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1244049,153.1860046v22.3864441c2.123642-0.4611664,4.0878601-0.9508057,5.8755875-1.4575043v-20.9289398 H98.1244049z"
  })))), /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    enableBackground: "new    ",
    d: "M33.510025,166.5142517 c0,5.7674103,15.7821007,10.4359894,35.2592163,10.4359894c19.107048,0,34.6614151-4.4977722,35.2307587-10.1171722V153.687027 h-5.0443497v1.0305023c-6.1602631-1.9585266-17.3762589-3.2680054-30.2205658-3.2680054 s-24.0659981,1.3094788-30.2205658,3.2680054v-1.0305023h-5.0329628v12.8272247H33.510025z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#EBEBEB",
    cx: 68.7407761,
    cy: 153.4706726,
    rx: 35.2592201,
    ry: 10.4360018
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#E60000",
    cx: 68.7407837,
    cy: 153.4421997,
    rx: 29.3836365,
    ry: 7.686089
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    enableBackground: "new    ",
    d: "M96.7295303,151.1079102L96.7295303,151.1079102 c-2.3969269-1.992691-6.4278488-3.0061035-9.895134-3.7177887c-3.7578354-0.740036-7.5626297-1.2175446-11.386795-1.4290466 c-7.8453598-0.5397797-15.7270622-0.1460724-23.4795761,1.1728516c-3.8828964,0.7059784-8.5401001,1.7535553-11.2216873,3.9853668 l0,0c-1.1386795,0.9166412-1.7080231,2.1065674-1.1386795,3.2907867c0.5693398,1.1842346,1.9528351,2.0553131,3.3647957,2.7328339 c-1.3094788-1.0817413-1.8048058-2.470932-0.8881683-3.7633362c0.8498268-1.0026093,1.9302063-1.7840881,3.1484489-2.277359 c3.8772011-1.838974,8.7279816-2.6929779,13.2826996-3.2509308c2.9833412-0.3643799,6.0008469-0.5693359,9.0240402-0.671814 c3.1050949-0.0498657,6.2102737,0.0946503,9.2973175,0.4326935c4.8621674,0.478241,9.9349823,1.2639313,14.2334976,2.9662628 c1.571373,0.620575,3.1541367,1.4119568,4.1106339,2.5050964c1.184227,1.3550262,0.8198471,2.8466949-0.6433563,4.0707855 c1.4119568-0.6775208,2.8466949-1.5656891,3.370491-2.7328339 C98.4318466,153.2543182,97.8568268,152.0302429,96.7295303,151.1079102z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    enableBackground: "new    ",
    d: "M96.7295303,151.1079102L96.7295303,151.1079102 c-2.3969269-1.992691-6.4278488-3.0061035-9.895134-3.7177887c-3.7578354-0.740036-7.5626297-1.2175446-11.386795-1.4290466 c-7.8453598-0.5397797-15.7270622-0.1460724-23.4795761,1.1728516c-3.8828964,0.7059784-8.5401001,1.7535553-11.2216873,3.9853668 l0,0c-1.1386795,0.9166412-1.7080231,2.1065674-1.1386795,3.2907867c0.5693398,1.1842346,1.9528351,2.0553131,3.3647957,2.7328339 c-1.3094788-1.0817413-1.8048058-2.470932-0.8881683-3.7633362c0.8498268-1.0026093,1.9302063-1.7840881,3.1484489-2.277359 c3.8772011-1.838974,8.7279816-2.6929779,13.2826996-3.2509308c2.9833412-0.3643799,6.0008469-0.5693359,9.0240402-0.671814 c3.1050949-0.0498657,6.2102737,0.0946503,9.2973175,0.4326935c4.8621674,0.478241,9.9349823,1.2639313,14.2334976,2.9662628 c1.571373,0.620575,3.1541367,1.4119568,4.1106339,2.5050964c1.184227,1.3550262,0.8198471,2.8466949-0.6433563,4.0707855 c1.4119568-0.6775208,2.8466949-1.5656891,3.370491-2.7328339 C98.4318466,153.2543182,97.8568268,152.0302429,96.7295303,151.1079102z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.1010818,160.5361786v-7.8227234l-5.9609909,1.1386719l-2.9548759-1.4916687v-2.1065521l10.4701653,0.1081696 h4.9532547v10.1741028H67.1010818z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.1010818,160.5361786v-7.8227234l-5.9609909,1.1386719l-2.9548759-1.4916687v-2.1065521l10.4701653,0.1081696 h4.9532547v10.1741028H67.1010818z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#EBEBEB",
    d: "M67.1010818,158.4068451v-7.8284149l-5.9609909,1.1386719l-2.9548759-1.4916687l10.4701653-2.0439301 h4.9532547v10.2253418H67.1010818z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 33.4815559,
    y1: 40.5293236,
    x2: 104,
    y2: 40.5293236,
    gradientTransform: "matrix(1 0 0 -1 0 194)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.35
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.2,
    fill: "url(#SVGID_4_)",
    enableBackground: "new    ",
    cx: 68.7407761,
    cy: 153.4706726,
    rx: 35.2592201,
    ry: 10.4360018
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EBEBEB",
    d: "M22.2029343,150.5727386c0,5.7674103,15.7821007,10.4359894,35.2592239,10.4359894 c19.1298218,0,34.6898804-4.5091705,35.230751-10.1342468v-13.1346741h-5.0386658v1.0305023 c-6.1545563-1.9585266-17.3762512-3.2680054-30.2205582-3.2680054s-24.0603027,1.3094788-30.2148666,3.2680206v-1.0305176 h-5.0443516v12.8329315H22.2029343z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_5_",
    d: "M22.2029343,150.5613403c0,5.7674255,15.787796,10.4416962,35.2592239,10.4416962 c19.1127396,0,34.6614075-4.503479,35.230751-10.1228638v-13.1403656h-5.0386658v1.0305023 c-6.1545563-1.9585266-17.3762512-3.2680054-30.2205582-3.2680054s-24.0603027,1.3094788-30.2148666,3.2680206v-1.0305176 h-5.0443516v12.8215332H22.2029343z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_6_)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.1122608,139.7837372v17.2510071c1.9223175,0.7303772,3.8861771,1.3463287,5.8812809,1.8446503v-19.0956573 H25.1122608z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8975983,139.7552795v21.065567c1.8977966,0.2201538,3.8506355,0.4251099,5.8585091,0.6148987V139.800827 L36.8975983,139.7552795z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6203041,145.015976v18.0196075c1.924366,0.0740204,3.8885918,0.1252594,5.8755875,0.1708069V145.015976H48.6203041z "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3714828,146.0066223v15.6625519c1.9888954-0.0227814,3.9474182-0.06073,5.8755875-0.1138763v-15.5486755H60.3714828 z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1283493,145.2721863v16.3969727c2.0097733-0.1594086,3.9853821-0.3302155,5.8755875-0.5237885v-15.8731842 H72.1283493z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.8795319,140.0798035v19.5397339c2.1293335-0.3795624,4.0878525-0.8027649,5.8755798-1.2696228v-18.2701111 H83.8795319z"
  })))), /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    enableBackground: "new    ",
    d: "M22.2029343,150.5613403 c0,5.7674255,15.787796,10.4416962,35.2592239,10.4416962c19.1127396,0,34.6614075-4.503479,35.230751-10.1228638v-13.1403656 h-5.0386658v1.0305023c-6.1545563-1.9585266-17.3762512-3.2680054-30.2205582-3.2680054 s-24.0603027,1.3094788-30.2148666,3.2680206v-1.0305176h-5.0443516v12.8215332H22.2029343z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#EBEBEB",
    cx: 57.4336891,
    cy: 137.523468,
    rx: 35.2592201,
    ry: 10.4360018
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#EBEBEB",
    cx: 57.4336891,
    cy: 137.5405426,
    rx: 35.2592201,
    ry: 10.4360018
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.7939911,144.6345215v-7.8113556l-5.9609909,1.1386871l-2.9548759-1.4859772v-2.123642l10.4701614,0.1024933h4.95895 v10.1797943H55.7939911z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.7939911,144.6345215v-7.8113556l-5.9609909,1.1386871l-2.9548759-1.4859772v-2.123642l10.4701614,0.1024933h4.95895 v10.1797943H55.7939911z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#EBEBEB",
    d: "M55.7939911,142.465332v-7.7885742l-5.9609909,1.16716l-2.9548759-1.491684l10.4701614-2.0439301h4.95895 v10.1570282H55.7939911z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 27.2188187,
    y1: 46.240345,
    x2: 92.6929092,
    y2: 46.240345,
    gradientTransform: "matrix(1 0 0 -1 0 194)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fill: "url(#SVGID_7_)",
    enableBackground: "new    ",
    d: "M87.6542435,137.7398071v1.0305023 c-6.1545563-1.9585266-17.3762512-3.2680054-30.2205582-3.2680054s-24.0546074-2.1122437-30.2148666-0.153717l0.5693398,1.4233398 l0.3928432,0.8540192l23.2233753,23.2176819c1.9699135,0.102478,3.9853783,0.1594086,6.0577736,0.1594086 c19.1127396,0,34.6614151-4.503479,35.2307587-10.1228638v-13.1403656H87.6542435z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EBEBEB",
    d: "M26.7177982,134.6369019c0,5.7674255,15.7821026,10.4416962,35.2592239,10.4416962 c19.129818,0,34.6898842-4.5148621,35.2307549-10.1399384v-13.1346741h-5.0386581v1.0305099 c-6.1545639-1.9585342-17.3762589-3.268013-30.2205658-3.268013s-24.0659981,1.3094788-30.2205658,3.2680054v-1.0305023H26.689333 v12.8329163H26.7177982z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_8_",
    d: "M26.7177982,134.6312103c0,5.7674103,15.7877979,10.4360046,35.2592239,10.4360046 c19.1127357,0,34.6614113-4.4977875,35.2307549-10.1171722v-13.1460571h-5.0386581v1.0305099 c-6.1545639-1.9585342-17.3762589-3.268013-30.2205658-3.268013s-24.0659981,1.3094788-30.2205658,3.2680054v-1.0305023 H26.689333v12.8272247H26.7177982z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_9_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_8_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_9_)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.5649185,121.6844254v19.9781418c1.9090958,0.8409882,3.8719482,1.5542297,5.8755913,2.135025v-22.1131668 H32.5649185z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.299015,121.6559601v24.3677521c1.8978004,0.2581024,3.8506393,0.4953156,5.8585091,0.7116699v-25.0509567 L44.299015,121.6559601z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0729675,127.7478943v20.8663177c1.924366,0.0796967,3.8885918,0.142334,5.8755875,0.1992645v-21.0655823H56.0729675 z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8241425,128.8922729V147.02005c1.9888916-0.030365,3.9474258-0.0740204,5.8755875-0.1309509v-17.9968262H67.8241425 z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.5980911,128.0496521V147.02005c2.0154572-0.1821899,3.9853821-0.387146,5.881279-0.6035004v-18.3668976H79.5980911z "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.3321838,122.031723v22.6255646c2.123642-0.4611664,4.0878601-0.9564819,5.8755875-1.4745789V122.031723H91.3321838z "
  })))), /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    enableBackground: "new    ",
    d: "M26.7177982,134.6312103 c0,5.7674103,15.7877979,10.4360046,35.2592239,10.4360046c19.1127357,0,34.6614113-4.4977875,35.2307549-10.1171722v-13.1460571 h-5.0386581v1.0305099c-6.1545639-1.9585342-17.3762589-3.268013-30.2205658-3.268013s-24.0659981,1.3094788-30.2205658,3.2680054 v-1.0305023H26.689333v12.8272247H26.7177982z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#EBEBEB",
    cx: 61.9485512,
    cy: 121.5876389,
    rx: 35.2592163,
    ry: 10.4360018
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#E60000",
    cx: 61.948555,
    cy: 121.5876389,
    rx: 29.3836327,
    ry: 7.686089
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    enableBackground: "new    ",
    d: "M89.9429932,119.2533417L89.9429932,119.2533417 c-2.4026108-1.9926834-6.4335403-3.0061111-9.9008179-3.7177887c-3.7578583-0.7399063-7.562645-1.2174072-11.386795-1.429039 c-7.8529205-0.5411148-15.742321-0.1474075-23.5023537,1.1728363c-3.8772049,0.705986-8.5401001,1.7535706-11.2216911,3.9853821 l0,0c-1.1386795,0.9166336-1.7080193,2.1065598-1.1386795,3.2907867c0.5693398,1.1842194,1.9528389,2.0553131,3.370491,2.7328262 c-1.3151741-1.0760498-1.8105011-2.470932-0.8938637-3.7576447c0.8485756-1.003952,1.9293213-1.7856827,3.1484489-2.277359 c3.8829002-1.8389664,8.7279854-2.7214432,13.2827034-3.2793961c2.9833412-0.3643723,6.000843-0.5693359,9.0297318-0.6661224 c3.1031265-0.0544662,6.2065773,0.08815,9.2916298,0.427002c4.8621597,0.4782486,9.9349823,1.2639389,14.23349,2.9662628 c1.5656815,0.6262741,3.1484528,1.4119644,4.1106339,2.5050964c1.184227,1.3550262,0.8141556,2.8751678-0.6490479,4.0707779 c1.4119644-0.6775131,2.8467026-1.5656815,3.370491-2.7328262 C91.6111603,121.3769836,91.0645981,120.1756744,89.9429932,119.2533417z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    enableBackground: "new    ",
    d: "M89.9429932,119.2533417L89.9429932,119.2533417 c-2.4026108-1.9926834-6.4335403-3.0061111-9.9008179-3.7177887c-3.7578583-0.7399063-7.562645-1.2174072-11.386795-1.429039 c-7.8529205-0.5411148-15.742321-0.1474075-23.5023537,1.1728363c-3.8772049,0.705986-8.5401001,1.7535706-11.2216911,3.9853821 l0,0c-1.1386795,0.9166336-1.7080193,2.1065598-1.1386795,3.2907867c0.5693398,1.1842194,1.9528389,2.0553131,3.370491,2.7328262 c-1.3151741-1.0760498-1.8105011-2.470932-0.8938637-3.7576447c0.8485756-1.003952,1.9293213-1.7856827,3.1484489-2.277359 c3.8829002-1.8389664,8.7279854-2.7214432,13.2827034-3.2793961c2.9833412-0.3643723,6.000843-0.5693359,9.0297318-0.6661224 c3.1031265-0.0544662,6.2065773,0.08815,9.2916298,0.427002c4.8621597,0.4782486,9.9349823,1.2639389,14.23349,2.9662628 c1.5656815,0.6262741,3.1484528,1.4119644,4.1106339,2.5050964c1.184227,1.3550262,0.8141556,2.8751678-0.6490479,4.0707779 c1.4119644-0.6775131,2.8467026-1.5656815,3.370491-2.7328262 C91.6111603,121.3769836,91.0645981,120.1756744,89.9429932,119.2533417z"
  })));
}

var _default = ic_saving_1;
exports.default = _default;